import { useState } from 'react';
import CallScheduleModal from '@/components/feature/CallScheduleModal';

export default function BookConsultationButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Floating button stack — bottom right */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">

        {/* Book Free Consultation */}
        <button
          onClick={() => setIsModalOpen(true)}
          className="group flex items-center gap-0 overflow-hidden cursor-pointer whitespace-nowrap transition-all duration-500 ease-in-out relative"
          style={{
            backgroundColor: '#f59e0b',
            border: '1px solid rgba(251,191,36,0.6)',
            boxShadow: '0 8px 32px rgba(245,158,11,0.35)',
            borderRadius: '9999px',
            height: '52px',
            paddingLeft: '14px',
            paddingRight: '14px',
          }}
          aria-label="Book Free Consultation"
        >
          <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110">
            <i className="ri-calendar-check-line text-black text-lg"></i>
          </span>
          <span
            className="overflow-hidden transition-all duration-500 ease-in-out max-w-0 group-hover:max-w-[200px] group-hover:ml-2"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '13px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#000',
            }}
          >
            Book Free Consultation
          </span>
          <span
            className="absolute inset-0 rounded-full animate-ping opacity-20 pointer-events-none"
            style={{ backgroundColor: '#f59e0b' }}
          />
        </button>

        {/* WhatsApp — visible on all screen sizes */}
        <a
          href="https://wa.me/message/OAKDCTBVIML6F1"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-0 overflow-hidden cursor-pointer whitespace-nowrap transition-all duration-500 ease-in-out relative"
          style={{
            backgroundColor: '#0f0f0f',
            border: '1px solid rgba(34,197,94,0.35)',
            boxShadow: '0 8px 28px rgba(34,197,94,0.18)',
            borderRadius: '9999px',
            height: '52px',
            paddingLeft: '14px',
            paddingRight: '14px',
          }}
          aria-label="Chat on WhatsApp"
        >
          <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110">
            <i className="ri-whatsapp-line text-green-400 text-lg"></i>
          </span>
          <span
            className="overflow-hidden transition-all duration-500 ease-in-out max-w-0 group-hover:max-w-[160px] group-hover:ml-2"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '13px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#4ade80',
            }}
          >
            Chat with Us
          </span>
          {/* subtle green pulse */}
          <span
            className="absolute inset-0 rounded-full animate-ping opacity-10 pointer-events-none"
            style={{ backgroundColor: '#22c55e' }}
          />
        </a>

      </div>

      {/* Modal */}
      <CallScheduleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
